<template>
<div>
<v-navigation-drawer app fixed v-model="drawer">
                <v-list dense nav>
                    <v-list-item to="/">
                        <v-list-item-action>
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Home</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item to="/InputProgramList">
                        <v-list-item-action>
                            <v-icon>mdi-view-list</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>一覧</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- <v-list-item to="/about">
                        <v-list-item-action>
                            <v-icon>mdi-help-circle</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>About</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item> -->

                    <v-list-item to="/signin">
                        <v-list-item-action>
                            <v-icon>mdi-login</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>ログイン</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item to="/signout">
                        <v-list-item-action>
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>ログアウト</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item to="/contact">
                        <v-list-item-action>
                            <v-icon>mdi-email</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>お問い合わせ</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                </v-list>
            </v-navigation-drawer>

    <v-app-bar color="primary" app dark>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>グローバル通知システム</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon to="/InputProgramList" id="btnList">
            <v-icon>mdi-view-list</v-icon>
        </v-btn>        
    </v-app-bar>      
</div>
</template>

<script>
export default {
    data: function() {
      return {
        drawer:null,
      }
    }
}  
</script>


